export const CATEGORY_EXCEPTIONS_IDS: string[] = ['c334', 'c4464', 'c98', 'c49'];
